import React from "react";
import { Element } from "react-scroll";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { Title, Container } from "./globalStyledComponents";
import { Button } from "react-bootstrap";
import { useAppContext } from "../appContext";


const StyledBlogs = styled.section`
  p {
    font-size: 1.25rem;
  }
  .img {
    width: 18rem;
    height: 18rem;
  }
`;

function Blogs() {
  const { theme } = useAppContext();

  return (
    <Element name={"Blogs"} id="blogs">
      <StyledBlogs className="section">
      <Container>
          <Container className="d-flex">
            <Title>
              <h2>Hey!! I write Blogs too</h2>
              <div className="underline"></div>
            </Title>
          </Container>
          <Container>
          <Container className="text-center mt-5">
                  <Link to="/All-Blogs">
                    <Button
                      size="lg"
                      variant={
                        theme === "light" ? "outline-dark" : "outline-light"
                      }
                    >
                      All Blogs
                    </Button>
                  </Link>
                </Container>
          </Container>
        </Container>
      </StyledBlogs>
    </Element>
  );
  
}

export default Blogs
